var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.319824H7.2C2.604 0.319824 0 2.92383 0 7.51982V20.1199C0 24.7158 2.604 27.3198 7.2 27.3198H19.8121C24.408 27.3198 27 24.7158 27 20.1199V7.51982C27 2.92383 24.408 0.319824 19.8121 0.319824Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1204 21.3173V18.7616C11.1204 18.1139 11.647 17.5878 12.2993 17.5837H14.6945C15.3497 17.5837 15.8809 18.1111 15.8809 18.7616V18.7616V21.3099C15.8809 21.8716 16.3373 22.3281 16.9031 22.3322H18.5372C19.3003 22.3341 20.0329 22.0345 20.5733 21.4994C21.1136 20.9644 21.4173 20.2378 21.4173 19.4801V12.2204C21.4173 11.6084 21.144 11.0278 20.6712 10.6351L15.1198 6.22742C14.1494 5.45646 12.7635 5.48137 11.8218 6.28668L6.38983 10.6351C5.8946 11.0162 5.59861 11.5985 5.58398 12.2204V19.4727C5.58398 21.0519 6.87347 22.3322 8.46413 22.3322H10.0609C10.3333 22.3341 10.5952 22.2281 10.7885 22.0375C10.9819 21.847 11.0906 21.5877 11.0906 21.3173H11.1204Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f1e6534e5095983f6e2b710421a2695e.svg";
export { ForwardRef as ReactComponent };